var _rect, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRivetBackground2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 311,
    viewBox: "0 0 403 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 310,
    transform: "matrix(-1 0 0 1 403 0)",
    fill: "#F26B49"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 403,
    height: 310
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 310,
    transform: "matrix(-1 0 0 1 403 0)",
    fill: "#F26B49"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.18 201.309C144.754 183.735 144.754 155.243 127.18 137.669C109.607 120.095 81.1142 120.095 63.5406 137.669L-174.047 375.257L-110.408 438.897L127.18 201.309Z",
    fill: "#45293F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 246L72 310.1H0.170013V274.5L43 246Z",
    fill: "#45293F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivetBackground2);
export default __webpack_public_path__ + "static/media/rivetBackground_2.581b0c35e96ba89452cd5786cf10541e.svg";
export { ForwardRef as ReactComponent };